import { trackButtonClick } from "@/utils/analytics";
import "../style/pdp.css";
import LivevoxChat from "./LivevoxChat";
import { IoDocumentTextOutline } from "react-icons/io5";

const NeedHelp = ({ propertyData, isForeclosure }) => {
  const handleGAEvents = (type) => {
    trackButtonClick({
      eventName: "contact_us",
      eventParams: { contact_type: type },
      eventCategory: "NEW-PDP",
      eventSource: `On ${type} Click`,
      eventLabel: `${propertyData?.propertyId}|${propertyData?.listingId}|${
        propertyData?.address?.streetNumber
      } ${propertyData?.address?.streetName}, ${
        propertyData?.address?.county
      }, ${propertyData?.address?.city}, ${propertyData?.address?.state}, ${
        propertyData?.address?.zip
      }|Referrer: Other|Foreclosure Property:${
        isForeclosure ? "Yes" : "No"
      }|Status:${propertyData?.commonAttributes?.status}`,
    });
  };

  return (
    <div id="pdp-contact-us" className="pdp-body-sec2 pl0 pr0 pt40">
      <div className="needhelp-box">
        <svg
          viewBox="0 0 1270 136"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_1109_20380" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 0C3.58172 0 0 3.58172 0 8V48V64V124C0 130.627 5.37259 136 12 136H1258C1264.63 136 1270 130.627 1270 124V48C1270 41.3726 1264.63 36 1258 36H198L177.61 8.17772C173.843 3.03729 167.852 0 161.478 0H8Z"
            ></path>
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0C3.58172 0 0 3.58172 0 8V48V64V124C0 130.627 5.37259 136 12 136H1258C1264.63 136 1270 130.627 1270 124V48C1270 41.3726 1264.63 36 1258 36H198L177.61 8.17772C173.843 3.03729 167.852 0 161.478 0H8Z"
            fill="white"
          ></path>
          <path
            d="M198 36L197.193 36.5911L197.493 37H198V36ZM177.61 8.17772L176.804 8.76883L177.61 8.17772ZM1 8C1 4.13401 4.13401 1 8 1V-1C3.02944 -1 -1 3.02944 -1 8H1ZM1 48V8H-1V48H1ZM1 64V48H-1V64H1ZM1 124V64H-1V124H1ZM12 135C5.92488 135 1 130.075 1 124H-1C-1 131.18 4.82031 137 12 137V135ZM1258 135H12V137H1258V135ZM1269 124C1269 130.075 1264.08 135 1258 135V137C1265.18 137 1271 131.18 1271 124H1269ZM1269 48V124H1271V48H1269ZM1258 37C1264.08 37 1269 41.9249 1269 48H1271C1271 40.8203 1265.18 35 1258 35V37ZM198 37H1258V35H198V37ZM176.804 8.76883L197.193 36.5911L198.807 35.4089L178.417 7.5866L176.804 8.76883ZM161.478 1C167.533 1 173.225 3.88543 176.804 8.76883L178.417 7.5866C174.461 2.18915 168.17 -1 161.478 -1V1ZM8 1H161.478V-1H8V1Z"
            fill="#E2EAF2"
            mask="url(#path-1-inside-1_1109_20380)"
          ></path>
        </svg>
        <div
          className="contact-us-title"
          role="heading"
          aria-level="2"
          tabIndex="0"
        >
          CONTACT US
        </div>
        <div className="row-structure">
          <div className="phone-number">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
              <path d="M9.2307 25.773C13.7832 30.1876 19.422 33.3204 25.5749 34.8542C26.0422 34.9502 26.5176 34.999 26.9944 35C28.8222 35.0029 30.574 34.2704 31.8561 32.9679L34.034 30.79C34.659 30.1647 35.0103 29.3165 35.0103 28.4321C35.0103 27.5478 34.659 26.6998 34.034 26.0743L29.853 21.8838C29.2253 21.2634 28.378 20.9153 27.4951 20.9153C26.6125 20.9153 25.7653 21.2634 25.1373 21.8838L23.0178 24.0033C20.2222 23.075 17.691 21.4878 15.6379 19.3753C13.5219 17.3251 11.9338 14.7932 11.0099 11.9955L13.1197 9.87596V9.87572C13.7474 9.25165 14.1003 8.40318 14.1003 7.51788C14.1003 6.63282 13.7475 5.78439 13.1197 5.16028L8.92924 0.96957C8.29539 0.360643 7.45039 0.0205078 6.5714 0.0205078C5.6924 0.0205078 4.84741 0.360618 4.21356 0.96957L2.03566 3.15721C0.376366 4.78795 -0.335118 7.1531 0.149289 9.42888C1.6787 15.5836 4.81222 21.2234 9.23051 25.7731L9.2307 25.773ZM3.40682 4.52849L5.58471 2.35059C5.84571 2.09863 6.19437 1.95799 6.55696 1.95799C6.91978 1.95799 7.26819 2.09863 7.52921 2.35059L11.7102 6.53156C11.9621 6.79256 12.1028 7.14097 12.1028 7.50381C12.1028 7.86638 11.9621 8.21504 11.7102 8.47606L9.23076 11.0138C9.00321 11.2436 8.90481 11.5715 8.96829 11.8889C9.87729 15.2746 11.7043 18.3437 14.248 20.7557C16.6605 23.2993 19.7292 25.1264 23.1148 26.0354C23.4322 26.0989 23.7601 26.0005 23.9898 25.7729L26.4983 23.2645H26.4986C26.7596 23.0125 27.108 22.8716 27.4708 22.8716C27.8334 22.8716 28.182 23.0125 28.4431 23.2645L32.624 27.4454V27.4452C32.8758 27.7062 33.0166 28.0548 33.0166 28.4174C33.0166 28.7802 32.8758 29.1289 32.624 29.3899L30.4752 31.5969C29.3086 32.7879 27.6132 33.2979 25.9832 32.9485C20.1918 31.5066 14.885 28.5579 10.6016 24.4023C6.44581 20.1189 3.49737 14.8123 2.0554 9.02071C1.70601 7.39073 2.21605 5.69531 3.40705 4.52873L3.40682 4.52849Z" fill="#20558B"/>
              <path d="M20.4215 0C20.0741 0 19.753 0.185312 19.5794 0.486113C19.4058 0.786914 19.4058 1.15753 19.5794 1.45836C19.753 1.75917 20.0741 1.94448 20.4215 1.94448C23.7738 1.94448 26.9888 3.27638 29.359 5.6466C31.7293 8.01713 33.0611 11.2319 33.0611 14.5841C33.0611 14.9315 33.2464 15.2525 33.5472 15.4262C33.848 15.5998 34.2186 15.5998 34.5195 15.4262C34.8203 15.2526 35.0056 14.9315 35.0056 14.5841C35.0056 12.0241 34.3317 9.50904 33.0516 7.29233C31.7717 5.07512 29.9305 3.23394 27.7134 1.9541C25.4964 0.674019 22.9814 0.000100007 20.4216 0.000100007L20.4215 0Z" fill="#20558B"/>
              <path d="M20.4215 4.86182C20.0741 4.86182 19.753 5.04713 19.5794 5.34793C19.4058 5.64873 19.4058 6.01935 19.5794 6.32018C19.753 6.62123 20.0741 6.80654 20.4215 6.80654C22.4844 6.80654 24.4628 7.6259 25.9216 9.0845C27.3802 10.5433 28.1996 12.5217 28.1996 14.5846C28.1996 14.932 28.3849 15.2531 28.686 15.4267C28.9868 15.6003 29.3574 15.6003 29.6582 15.4267C29.959 15.2531 30.1443 14.9321 30.1443 14.5846C30.1443 12.0061 29.1198 9.53303 27.2965 7.70978C25.4732 5.88654 23.0001 4.86197 20.4217 4.86197L20.4215 4.86182Z" fill="#20558B"/>
              <path d="M23.3382 14.584C23.3382 14.9315 23.5235 15.2525 23.8243 15.4262C24.1253 15.5997 24.496 15.5997 24.7968 15.4262C25.0976 15.2526 25.2829 14.9315 25.2829 14.584C25.2829 13.2949 24.7707 12.0582 23.859 11.1466C22.9473 10.2349 21.7107 9.72266 20.4215 9.72266C20.0741 9.72266 19.753 9.90797 19.5794 10.2088C19.4058 10.5096 19.4058 10.8802 19.5794 11.1813C19.753 11.4821 20.0741 11.6674 20.4215 11.6674C21.195 11.6674 21.937 11.9745 22.4839 12.5217C23.0311 13.0686 23.3382 13.8106 23.3382 14.5841L23.3382 14.584Z" fill="#20558B"/>
            </svg> */}
            <IoDocumentTextOutline size={40} color="#20558B" />

            <a
              href="/support"
              className="faq-link"
              eventname="faq"
              onClick={() => handleGAEvents("faq")}
            >
              <div>Visit our FAQ Page</div>
              <div className="contact-us-text">FAQs</div>
            </a>
            {/* <a href="tel:8558821314" className="phone-number-link" eventname="Phone" onClick={() => handleGAEvents("Phone")}>
                <div>(855) 882 - 1314</div>
                <div className='contact-us-text'>Phone</div>
              </a> */}
            <div className="divider-faq"></div>
          </div>
          <div className="e-mail">
            <svg
              className="email-svg"
              width="38"
              height="27"
              viewBox="0 0 38 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M3.70738 0C1.65058 0 0 1.73002 0 3.80851V23.0542C0 25.1327 1.65049 26.8773 3.70738 26.8773H34.2926C36.3494 26.8773 38 25.1327 38 23.0542V3.80851C38 1.73002 36.3495 0 34.2926 0H3.70738ZM3.70738 1.85348H34.2926C34.5671 1.85348 34.826 1.93236 35.06 2.04161L20.1439 16.2047C19.4593 16.8547 18.5706 16.8547 17.8847 16.2047L2.93964 2.04161C3.17399 1.93236 3.43292 1.85348 3.70704 1.85348H3.70738ZM1.88261 3.59128L12.4393 13.5985L2.05557 23.9674C1.92562 23.6975 1.85289 23.3881 1.85289 23.0552V3.8095C1.85289 3.73418 1.87455 3.66468 1.88166 3.59227L1.88261 3.59128ZM36.1172 3.59128C36.1247 3.66369 36.146 3.73319 36.146 3.80851V23.0542C36.146 23.3826 36.0697 23.6849 35.9433 23.9522L25.5894 13.5834L36.1172 3.59128ZM24.2423 14.8721L34.3794 25.0241H34.2925H3.70723H3.63483L13.7869 14.887L16.6108 17.5515C17.9558 18.8264 20.0741 18.8284 21.4189 17.5515L24.2423 14.8721Z"
                fill="#20558B"
              ></path>
            </svg>
            <a
              href="mailto:customercare@hubzu.com"
              className="email-link"
              eventname="Email"
              onClick={() => handleGAEvents("Email")}
            >
              <div>customercare@hubzu.com</div>
              <div className="contact-us-text">Email</div>
            </a>
            <div className="divider-email"></div>
          </div>
          <LivevoxChat onChatClick={() => handleGAEvents("LiveOnlineChat")} />
        </div>
      </div>
    </div>
  );
};
export default NeedHelp;
